export const POSTHOG_EVENTS = {
  VIEW: 'view',
  MINHAS_FATURAS_ACESSADAS: 'minhas_faturas_acessadas',
  TERMO_CONFISSAO_DIVIDA_ASSINADO: 'termo_confissao_divida_assinado',
  PROPOSTA_ACEITA: 'proposta_aceita',
  SIMULACAO_NEGOCIACAO_REALIZADA: 'simulacao_negociacao_realizada'
}
